<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="margin-right: 10px">付费时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions3" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="btn-box">
        <input-search placeholder="车牌号/车主姓名/经办人姓名" @search="searchKey" />
        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('013012002') !== -1" value="导出" style="margin-left: 10px;"/>
      </div>
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="缴费方式" :selectKey="'paymentMethod'" :selectData="payTypeList" @search="search"/>
        <input-select selectTitle="缴费状态" style="margin-left: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="账单类型" style="margin-left: 10px;" :selectData="billTypeList" @search="search" :selectKey="'billType'" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'
  import {nError, nSuccess} from "../../../utils/notice";

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'parking-finance-monthly-payment',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '包月账单'
        }],
        // addCustom: 'amount-add',
        exportUrl: '',
        timevalue: [],
        pickerOptions3: {
          shortcuts: [{
            text: '过去一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        payTypeList: [
          {
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '月缴'
        }, {
          key: '2',
          label: '季缴'
        }, {
          key: '3',
          label: '半年缴'
        }, {
          key: '4',
          label: '年缴'
        }],
        payStatusList: [
          {
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }, {
          key: '2',
          label: '已退款'
        }],
        billTypeList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '新增'
          }, {
            key: '2',
            label: '续费'
          }, {
            key: '3',
            label: '退费'
          },
        ],
        operationArr: ["modifyInvoiceStatus"],
        tableHead: [
          {
          prop: 'carOwnerName',
          label: '车主姓名'
        }, {
          prop: 'carNumber',
          label: '车牌号'
        }, {
          prop: 'paymentMethodText',
          label: '缴费方式',
          width: '100px'
        }, {
          prop: 'billTypeText',
          label: '账单类型',
          width: '100px'
        }, {
          prop: 'money',
          label: '金额(元)',
          width: '100px'
        }, {
          prop: 'payStatusText',
          label: '缴费状态',
        }, {
          prop: 'payTime',
          label: '缴费时间',
          width: '180px'
        }, {
          prop: 'operator',
          label: '经办人'
        }, {
          prop: 'invoiceStatus',
          label: '开票状态',
          width: '120px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusList: [
            {
              code: '0',
              name: '未开票'
            }, {
              code: '1',
              name: '已开票'
            }, {
              code: '2',
              name: '开票中'
            }
          ],
          changeStatus: true
        }, {
          prop: 'invoiceNo',
          label: '发票号',
          width: '180px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusAlreadyOnPageChangeStatus: 'invoiceStatus',
          changeInfo: true
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          paymentMethod: '',
          payStatus: '',
          billType: '',
          startTime: '',
          endTime: '',
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportParkingMonthBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&paymentMethod=${this.requestData.paymentMethod}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}&payStatus=${this.requestData.payStatus}&billType=${this.requestData.billType}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getParkingMonthBillPage, reqData)
          .then(res => {
            if (res.data.retCode == 1) {
              let data = res.data.data.list
              data.map(v => {
                v.invoiceStatusChangeStatus = true
                if (v.paymentMethod === '1') {
                  v.paymentMethodText = '月缴'
                } else if (v.paymentMethod === '2') {
                  v.paymentMethodText = '季缴'
                } else if (v.paymentMethod === '3') {
                  v.paymentMethodText = '半年缴'
                } else if (v.paymentMethod === '4') {
                  v.paymentMethodText = '年缴'
                }
                if (v.consumeTime) {
                  v.consumeTime = v.consumeTime.slice(0, 19)
                }
                if (v.billType === '1') {
                  v.billTypeText = '新增'
                } else if (v.billType === '2') {
                  v.billTypeText = '续费'
                } else if (v.billType === '3') {
                  v.billTypeText = '退费'
                }
                if (v.payStatus === '0') {
                  v.payStatusText = '未缴费'
                } else if (v.payStatus === '1') {
                  v.payStatusText = '已缴费'
                } else if (v.payStatus === '2') {
                  v.payStatusText = '已退款'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      modifyInvoiceStatus (data) {
        // if (data.invoiceStatus === '1') {
        //   nError('已开票的不允许修改')
        //   return false
        // } else {
        //
        // }

        data.invoiceStatusChangeStatus = false
        this.currentLineData = data
      },
      // 修改开票状态
      statusChange (data) {
        this.currentLineData.invoiceStatus = data
        for (let i in this.currentLineData) {
          if (this.currentLineData[i] === '--') {
            this.currentLineData[i] = ''
          }
        }
        if (data === '0' || data === '2') {
          this.currentLineData.invoiceNo = ''
          this.$axios.post(api.updateParkingMonthBill, this.currentLineData)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        }
      },
      // 修改发票号
      statusInfoChange () {
        if (!this.currentLineData.invoiceNo) {
          nError('请输入发票号')
          return false
        }
        this.$axios.post(api.updateParkingMonthBill, this.currentLineData)
          .then(res => {
            nSuccess('修改成功')
            this.getPage()
          })
          .catch(errorHandler('修改失败'))
      },

      // 批量修改发票状态
      updatePatchElectricConsumptionRecord () {
        let reqData = []
        let sumMoney = 0
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.invoiceStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              reqData.push(v)
              reqData[reqData.length - 1].invoiceStatus = '1'
              sumMoney = sumMoney + parseFloat(v.money)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未开票的充值记录')
          return false
        }
        this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updatePatchElectricConsumptionRecord, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(() => {
                errorHandler('修改失败')
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      }
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/ParkingFinance/ParkingFinanceMonthlyPayment.vue